<template>
  <div :class="classes">
       <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" :current-page="currentPage" isAddPageToRouter>
      <wt-table :list="tableData" :labels="tableLabels">
          <slot/>
      </wt-table>
      </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-label-table'

export default {
  name: 'pt-label-table',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    currentPage: {
      type: Number,
      default: 0
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    getTableData (page, next) {
      this.$emit('getTableData', page, next)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
